import { wrapSvg } from '../../../common/util/SvgImage';

export const BackgroundElement = wrapSvg(
  <svg
    width="1236"
    height="474"
    viewBox="0 0 1236 474"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-192"
      y="889.142"
      width="1475.57"
      height="761.648"
      rx="374"
      transform="rotate(-45 -192 889.142)"
      fill="#18CDCD"
    />
  </svg>,
);

export const BackgroundElementExperiment = wrapSvg(
  <svg
    width="1236"
    height="474"
    viewBox="0 0 1236 474"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="-192"
      y="889.142"
      width="1475.57"
      height="761.648"
      rx="374"
      transform="rotate(-45 -192 889.142)"
      fill="#73E1E1"
    />
  </svg>,
);
